module.exports = __webpack_public_path__ + "static/media/card1_3.4a909061.png";